import { Injectable } from '@angular/core';
import {MatSnackBar,  MatSnackBarHorizontalPosition,  MatSnackBarVerticalPosition,} from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
providedIn: 'root'
})
export class SnackBarService {

constructor(private snackBar:MatSnackBar, private translate:TranslateService) { }

  openSnackBar(message: string, action: string = "OK") {
  	this.snackBar.open(message, action, {
  	duration: 1850,
    horizontalPosition:'center',
    panelClass:'snackbar'
  	});
  }

  save(message:string = "error.saved"){
    let action = "OK"
    this.snackBar.open(this.translate.instant(message), action, {
  	  duration: 1850,
      horizontalPosition:'center',
      panelClass:'snackbar'
  	});
  }
  error(message:string = "error.general", time:number = 3000){
    let action = "OK"
    this.snackBar.open(this.translate.instant(message), action, {
  	  duration: time,
      horizontalPosition:'center',
      panelClass:'error-snackbar'
  	});
  }

  statusError(code:string){
    switch (code){
        case 'aac3b86f-999d-4ade-8bc1-fd65f5a2c111':
          this.error('error.student-already-enrolled');
        return "enrolled";
        case '23bd9dbf-6b9b-41cd-a99e-4844bcf3077f':
          this.error('error.vat-inuse');
        return "vatnumber";
        case 'Inactive account.':
          this.error('error.activation-needed');
        return "inactive";
        case 'Invalid credentials.':
          this.error('error.credentials');
        return "inactive";
        case 'f74f7836-198e-4b4d-878e-ee839ed54b2d':
          this.error('error.series-closed');
        return 'closed_series_selected';
        case 'Username not found':
          this.error('error.username-not-found');
        return 'Username not found';
        case 'Username is communication email address':
          this.error('error.username-is-communication')
        return 'Username is communication email'
        default:
          this.error();
        return "error";
    }
  }

  invalidForm(){
    let message = "error.invalid-form";
    let action = "OK"
    this.snackBar.open(this.translate.instant(message), action, {
  	  duration: 1850,
      horizontalPosition:'center',
      panelClass:'error-snackbar'
  	});
  }
}
